<template>
	<div class="container mt-8">
		<h1 class="text-center mb-2">{{ golfCourse.name }}</h1>

		<div class="mgs-panel-block bg-white p-4">
			<course-form
				class="w-full"
				ref="courseEditForm"
				:golf-course="golfCourse"
				@course-updated="edited"
			></course-form>
			<h3 class="text-center mb-2 font-semibold">Tees</h3>
			<div class="flex justify-center mb-2">
				<course-tees
					:key="`course-${golfCourse.uuid}-${i}`"
					:golf-course="golfCourse"
					:course-tee="tee"
					v-for="(tee, i) in courseTees"
				></course-tees>
			</div>
			<base-modal ref="createCourseTeeModal">
				<base-form
					class="w-full"
					ref="teeForm"
					:form-data="teeForm"
					@submitted="addTee"
				></base-form>
				<template v-slot:modal-button="{ showModal }">
					<div class="flex justify-center mt-4">
						<base-button @click="showModal">Create New</base-button>
					</div>
				</template>
			</base-modal>
		</div>
	</div>
</template>
<script>
/** @format */
import CourseFields from '@/fields/courses';
export default {
	name: 'CoursesEdit',
	props: {
		golfCourse: {
			type: Object,
			required: true
		}
	},
	components: {
		'course-form': () => import(/* webpackChunkName: "CourseForm" */ './../components/Forms/Course'),
		'course-tees': () => import(/* webpackChunkName: "CourseTees" */ './../components/Course/Tees')
	},
	methods: {
		edited(course) {
			console.log('course');
		},
		addTee(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving tee data.'});
			this.$store
				.dispatch('courses/addTee', {golfCourse: this.golfCourse, payload})
				.then((response) => {
					this.$refs.teeForm.resetFieldValues();
					this.$refs.createCourseTeeModal.closeModal();
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course tee added successfully.'});
					this.courseTees = response.data.data.tees;
				})
				.finally(() => {
					this.$refs.teeForm.submitting = false;
				});
		}
	},
	data() {
		return {
			mode: 'editForm',
			teeForm: [
				{
					name: 'tee',
					label: 'Tee',
					component: 'base-input'
				},
				{
					name: 'hex',
					label: 'Colour (Hex Code) if applicable',
					component: 'base-input'
				}
			],
			courseTees: this.golfCourse.tees
		};
	}
};
</script>
